module.exports = __webpack_public_path__ + "img/red-pack.b24502fd.png";